import type { Cart } from "../lib/cart.js";
import { formatMoney } from "../lib/money.js";
import "./Ticket.css";

interface TicketProps {
  cart: Cart;
  /** Display-only draft number for this visit — see `App.tsx`. */
  ticketNumber: number | null;
  shopName: string;
}

export default function Ticket({ cart, ticketNumber, shopName }: TicketProps) {
  const empty = cart.lines.length === 0;

  return (
    <div className="ticket" id="ticket">
      <div className="ticket__head">
        <p className="ticket__shop">{shopName}</p>
        <p className="ticket__no">
        {ticketNumber === null
          ? "TICKET"
          : `TICKET #${String(ticketNumber).padStart(3, "0")}`}
      </p>
      </div>

      <div className="ticket__tear" aria-hidden="true" />

      {empty ? (
        <p className="ticket__empty">
          Nothing on the ticket yet. Add something from the menu.
        </p>
      ) : (
        <ul className="ticket__lines">
          {cart.lines.map((line) => (
            <li className="tline" key={line.menuItemId}>
              <span className="tline__qty">{line.quantity}&times;</span>
              <span className="tline__name">
                {line.name}
                <button
                  type="button"
                  className="tline__remove"
                  onClick={() => cart.remove(line.menuItemId)}
                >
                  remove<span className="u-sr-only"> {line.name}</span>
                </button>
              </span>
              <span className="tline__amount">
                {formatMoney(line.priceCents * line.quantity)}
              </span>
            </li>
          ))}
        </ul>
      )}

      <div className="ticket__tear" aria-hidden="true" />

      <p className="ticket__total">
        <span>Total</span>
        <span className="ticket__totalAmount">{formatMoney(cart.totalCents)}</span>
      </p>
    </div>
  );
}
